import React from 'react';
import PropTypes from 'prop-types';
import { TextEditor } from '../../../../Modules';
import styles from '../../Form.scss';

export default class ContentBlockWidget extends React.Component {
  static propTypes = {
    editing: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    schema: PropTypes.object.isRequired,
    uiSchema: PropTypes.object.isRequired,
    formData: PropTypes.object
  };

  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
  }

  onChange(value) {
    this.props.onChange({
      uiSchema: { ...this.props.uiSchema, 'ui:content': value },
      schema: this.props.schema,
      formData: this.props.formData
    });
  }

  render() {
    const { uiSchema, editing } = this.props;
    const hasContent =
      uiSchema['ui:content'] === null ||
      uiSchema['ui:content'].replace(/(<h1>)(<br>)(<\/h1>)/gim, '') !== '';
    return (
      <div>
        {editing &&
          <TextEditor
            extended
            value={uiSchema['ui:content']}
            onChange={this.onChange}
            modules={{
              toolbar: [
                [{ header: [1, 2, false] }],
                ['bold', 'italic'],
                [{ list: 'ordered' }, { list: 'bullet' }],
                ['link']
              ]
            }}
            formats={['bold', 'italic', 'link', 'list', 'header']}
          />}
        {!editing &&
          hasContent &&
          <div
            style={{ wordBreak: 'break-word' }}
            dangerouslySetInnerHTML={{ __html: uiSchema['ui:content'] }}
          />}
        {!editing &&
          !hasContent &&
          <div>
            <h1 className={styles.questionPlaceholder}>Heading</h1>
            <p className={styles.questionPlaceholder}>Description</p>
          </div>}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./webpack/components/Document/Form/Builder/Widgets/ContentBlock.js